/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPharmacyImplantStocks } from 'app/entities/pharmacy-implant-stock/pharmacy-implant-stock.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-implant-bill-item.reducer';

export const PharmacyImplantBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacyImplantStocks = useAppSelector(state => state.pharmacyImplantStock.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const pharmacyImplantBillItemEntity = useAppSelector(state => state.pharmacyImplantBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyImplantBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyImplantBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyImplantBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-implant-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyBills({}));
    dispatch(getPharmacyImplantStocks({}));
    dispatch(getClinicalDictionaries({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.qty !== undefined && typeof values.qty !== 'number') {
      values.qty = Number(values.qty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.cessAmount !== undefined && typeof values.cessAmount !== 'number') {
      values.cessAmount = Number(values.cessAmount);
    }
    if (values.freeQty !== undefined && typeof values.freeQty !== 'number') {
      values.freeQty = Number(values.freeQty);
    }

    const entity = {
      ...pharmacyImplantBillItemEntity,
      ...values,
      pharmacyBill: pharmacyBills.find(it => it.id.toString() === values.pharmacyBill?.toString()),
      pharmacyStock: pharmacyImplantStocks.find(it => it.id.toString() === values.pharmacyStock?.toString()),
      uqcType: clinicalDictionaries.find(it => it.id.toString() === values.uqcType?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyImplantBillItemEntity,
          pharmacyBill: pharmacyImplantBillItemEntity?.pharmacyBill?.id,
          pharmacyStock: pharmacyImplantBillItemEntity?.pharmacyStock?.id,
          uqcType: pharmacyImplantBillItemEntity?.uqcType?.id,
          scheme: pharmacyImplantBillItemEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyImplantBillItem.home.createOrEditLabel" data-cy="PharmacyImplantBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.home.createOrEditLabel">
              Create or edit a PharmacyImplantBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-implant-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyImplantBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.chargedMrp')}
                id="pharmacy-implant-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.qty')}
                id="pharmacy-implant-bill-item-qty"
                name="qty"
                data-cy="qty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.manufacDate')}
                id="pharmacy-implant-bill-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.expDate')}
                id="pharmacy-implant-bill-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.active')}
                id="pharmacy-implant-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.cursor')}
                id="pharmacy-implant-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.timestampentry')}
                id="pharmacy-implant-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.microSec')}
                id="pharmacy-implant-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.lastupdated')}
                id="pharmacy-implant-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.discount')}
                id="pharmacy-implant-bill-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.paidAmount')}
                id="pharmacy-implant-bill-item-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.taxCode')}
                id="pharmacy-implant-bill-item-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.cessAmount')}
                id="pharmacy-implant-bill-item-cessAmount"
                name="cessAmount"
                data-cy="cessAmount"
                type="text"
              />
              <UncontrolledTooltip target="cessAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.help.cessAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.exempted')}
                id="pharmacy-implant-bill-item-exempted"
                name="exempted"
                data-cy="exempted"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="exemptedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.help.exempted" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.freeQty')}
                id="pharmacy-implant-bill-item-freeQty"
                name="freeQty"
                data-cy="freeQty"
                type="text"
              />
              <UncontrolledTooltip target="freeQtyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyImplantBillItem.help.freeQty" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-implant-bill-item-pharmacyBill"
                name="pharmacyBill"
                data-cy="pharmacyBill"
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.pharmacyBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-bill-item-pharmacyStock"
                name="pharmacyStock"
                data-cy="pharmacyStock"
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.pharmacyStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantStocks
                  ? pharmacyImplantStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-bill-item-uqcType"
                name="uqcType"
                data-cy="uqcType"
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.uqcType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-implant-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.pharmacyImplantBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-implant-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyImplantBillItemUpdate;
